import { track } from '@web-platform/shared-acorn-tracking/src/funnelEvents';
import { ANALYTICS_EVENTS } from '@web-platform/shared-universal-constants-tracking';
import { getUserSearch } from '@web-platform/shared-universal-redux/src/state';
import { searchEvent } from '@web-platform/shared-universal-tracking/src/funnelEvents/searchEvent';

import type { StoreType } from '@web-platform/shared-universal-types/src/redux/state/state-shared-types';

export const emitSearchEvent = (store: StoreType, viewId: string): void => {
  const search = getUserSearch(store.getState());

  const { eventName, funnelDimensions, opts } = searchEvent({
    businessDomain: 'FLIGHT',
    eventName: ANALYTICS_EVENTS.FUNNEL.DAY_VIEW.NAME,
    previousEventId: null,
    search,
    viewId,
  });

  track(eventName, funnelDimensions, opts);
};
